import React, { useState } from "react";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import "./Shipments.css";

// components imports
import TicketCreateModal from "./Components/TicketCreateModal/TicketCreateModal";
import AssignPickup from "./Components/AssignPickup/AssignPickup";
import InvoiceModal from "../../../../../Components/InvoiceModal/InvoiceModal";
import Confirm from "../../../../../Components/Popups/Confirm";
import PackageImageUploadModal from "./Components/PackageImageUploadModal/PackageImageUploadModal";
// apis imports
import {
  fetchShipments,
  cancelShipment,
  fetchShipmentDataById,
} from "../../../../../services/ShipperServices/Shipments/shipments.services";
import { updateUser } from "../../../../../store/userSlice";
import CircularLoader from "../../../../../Components/CircularLoader/CircularLoader";
import ShipmentsTable from "../../../../../Components/BoltTable/BoltTable";
import StatusIcons from "../../../../../Components/StatusIcons/StatusIcons";
import ActionDropDown from "./Components/TicketCreateModal/ActionDropDown/ActionDropDown";
import BoltButton from "../../../../../Components/UI/Buttons/BoltButton";

// library imports
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdComment } from "react-icons/md";
import { IoMdWarning } from "react-icons/io";
import { MdPending } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { convertTime } from "../../../../../helpers/helpers";
import HyperLink from "../../../../../Components/HyperLink/HyperLink";

const OneTimeShipperShipments = () => {
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [labelDownloading, setLabelDownloading] = useState("");
  const [shipments, setShipments] = useState([]);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [assignPickupModal, setAssignPickupModal] = useState(false);
  const [packageImageUploadModal, setPackageImageUploadModal] = useState(false);
  const [selectedShipmentForUpload, setSelectedShipmentForUpload] =
    useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const [cancelingShipment, setCancelingShipment] = useState();
  const setSnack = useSnackBar();
  const user = useSelector((state) => state.user);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [ticketCreateModal, setTicketCreateModal] = useState(false);

  const handleReShip = async (row) => {
    try {
      let data = await fetchShipmentDataById(row?.id);
      if (Object.keys(data?.data?.result).length !== 0) {
        localStorage.setItem("Reship", JSON.stringify(data?.data?.result));
        Navigate("/");
      } else {
        setSnack((snack) => ({
          ...snack,
          open: true,
          text: "No shipment data available",
          severity: "warning",
        }));
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: "Something went wrong",
        severity: "error",
      }));
    }
  };

  const handleTicketOpen = (row) => {
    if (row?.tickets?.length > 0 && row?.tickets[0]?.created_by == user.id)
      Navigate({
        pathname: "/Tickets",
        search: `?ticket_no=${row?.tickets[0]?.ticket_no}`,
      });
    else setTicketCreateModal(row);
  };

  const printLabel = async (row) => {
    setLabelDownloading("label" + row?.id);
    try {
      fetch(row?.single_shipping_labels.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${row.tattension + " " + row.shipment_tracking_id} Label.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLabelDownloading("");
        });
    } catch (error) {
      setLabelDownloading("");
    }
  };
  const printDeclaration = async (row) => {
    setLabelDownloading("Declaration" + row?.id);
    try {
      fetch(row?.single_shipping_invoice.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${row.tattension + " " + row.shipment_tracking_id} Declaration.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLabelDownloading("");
        });
    } catch (error) {
      setLabelDownloading("");
    }
  };
  const handleCancelShipment = async (id) => {
    setCancelingShipment(true);
    try {
      const response = await cancelShipment(id);
      if (!response.error) {
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment?.id === id) {
                return {
                  ...shipment,
                  shipment_status: response?.data?.result?.shipment_status,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
        setCancelingShipment(false);
        setConfirmCancel(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message,
            severity: "success",
          };
        });
      } else {
        setCancelingShipment(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text:
              response?.error?.response?.data?.message ??
              "Something went wrong",
            severity: "error",
          };
        });
      }
    } catch (error) {
      setCancelingShipment(false);
      setSnack({
        open: true,
        text: error?.message || "Something went wrong!",
        severity: "error",
      });
    }
  };
  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 1,
      label: "Carrier",
      render: (row) => (
        <>
          <img
            src={row?.shipping_company?.shipping_company?.logo_url}
            alt={
              row?.shipping_company?.shipping_company?.name || "Carrier logo"
            }
            loading="lazy"
          />
        </>
      ),
      width: "200px",
      fixed: "left",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 2,
      label: "Status",
      render: (row) => {
        if (
          row?.shipment_type === "oneTimeShipper" &&
          (row?.is_package_image === "0" || row?.is_package_image === 0)
        ) {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "var(--color-ui-text)",
                minWidth: 0,
                gap: "8px",
              }}
              className="items-center"
            >
              <div className="flex-shrink-0">
                <IoMdWarning
                  className="icon__status_boltTable"
                  style={{ color: "var(--color-danger-text)" }}
                  size={13}
                />
              </div>
              <div
                className="content__wrapping_boltTable"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                }}
              >
                IMAGES REQUIRED
              </div>
              <BoltButton
                label="Upload"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedShipmentForUpload(row);
                  setPackageImageUploadModal(true);
                }}
                variant="primary"
                size="sm"
                className="min-h-[24px] px-2 py-0.5 text-xs flex-shrink-0"
              />
            </div>
          );
        }
        if (
          row?.shipment_type === "oneTimeShipper" &&
          row?.is_package_image !== "0" &&
          row?.is_package_image !== 0
        ) {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "var(--color-ui-text)",
                minWidth: 0,
              }}
              className="items-center"
            >
              <div className="flex-shrink-0 mr-[2px]">
                <MdPending
                  className="icon__status_boltTable"
                  style={{ color: "#0043CE" }}
                  size={13}
                />
              </div>
              <div
                className="content__wrapping_boltTable"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                }}
              >
                PENDING ADMIN APPROVAL
              </div>
            </div>
          );
        }
        return <StatusIcons status={row?.shipment_status} />;
      },
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 2.5,
      label: "Type",
      render: (row) => {
        if (row?.shipment_type === "oneTimeShipper") {
          return <>-</>;
        }
        return <>{row?.shipment_type ?? "-"}</>;
      },
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 3,
      label: "Service",
      render: (row) => <>{row?.service_type ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 51,
      label: "Ticket",
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <div
              className="table_action__btn"
              onClick={() => {
                handleTicketOpen(row);
              }}
              style={{
                background:
                  row?.tickets?.length > 0 &&
                  row?.tickets[0]?.created_by == user.id &&
                  (row?.tickets[0]?.status == "Open" ||
                    row?.tickets[0]?.status == "Dispute" ||
                    row?.tickets[0]?.status == "Disputed")
                    ? "red"
                    : "none",
                color:
                  row?.tickets?.length > 0 &&
                  row?.tickets[0]?.created_by == user.id &&
                  (row?.tickets[0]?.status == "Open" ||
                    row?.tickets[0]?.status == "Dispute" ||
                    row?.tickets[0]?.status == "Disputed")
                    ? "white"
                    : "none",
              }}
            >
              <MdComment size={10} />
              Ticket
            </div>
          </div>
        </>
      ),
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 6,
      label: "Pickup ID",
      render: (row) => <>{row?.PickupID ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 62,
      label: "Pickup",
      render: (row) => (
        <>
          {" "}
          {row.PickupDate &&
            `${row.PickupDate?.slice(0, 10)}  ${
              row.readyopentime ? row.readyopentime?.slice(0, 5) : ""
            }${row.readyopentime && row.readyclosetime ? "-" : ""}${
              row.readyclosetime ? row.readyclosetime?.slice(0, 5) : ""
            }`}
          {!row.PickupDate && (
            <div
              className="putable__arrangepickup_btn"
              onClick={() => setAssignPickupModal(row)}
            >
              Arrange Pickup <FaEdit size={10} style={{ marginLeft: "5px" }} />
            </div>
          )}
        </>
      ),
      width: "250px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 7,
      label: "Bolt Tracking ID",
      render: (row) => (
        <>
          <HyperLink code={row?.tracking_id} />
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 8,
      label: "Carrier Tracking ID",
      render: (row) => (
        <>
          <HyperLink code={row?.shipment_tracking_id} />
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 9,
      label: "Delivery",
      render: (row) => <>{row?.delivery_date?.slice(0, 10) ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 11,
      label: "Est. Delivery Date",
      render: (row) => <>{row?.estimated_delivery_date?.slice(0, 10) ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 12,
      label: "Payment Status",
      render: (row) => <StatusIcons status={row?.payment_status ?? "Paid"} />,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 14,
      label: "Internal Status",
      render: (row) => <StatusIcons status={row?.user_invoice_status} />,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 13,
      label: "Weight",
      render: (row) => <>{row?.total_weight ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 15,
      label: "Customer Name",
      render: (row) => <>{row?.tattension ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 16,
      label: "Pickup City",
      render: (row) => <>{row?.fcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 17,
      label: "Pickup Address",
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.faddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 18,
      label: "Pickup Notes",
      render: (row) => <>{row?.finstructions ?? "-"}</>,
      width: "250px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 19,
      label: "Delivery City",
      render: (row) => <>{row?.tcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 20,
      label: "Delivery Address",
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.taddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 21,
      label: "Total",
      render: (row) => (
        <>
          {" "}
          <div>
            <div
              className={`${
                row?.shipment_charges?.length > 1
                  ? "shipments__total_updatedamount"
                  : ""
              }`}
            >
              {row.Total ?? "-"}{" "}
              <sup>
                {row?.shipment_charges?.length > 1
                  ? `*${row?.shipment_charges?.length}`
                  : ""}
              </sup>
            </div>

            <div className="shipments__total_prevamount">
              {row?.shipment_charges?.length > 1
                ? row?.shipment_charges[row?.shipment_charges?.length - 2]
                    ?.total
                : ""}
            </div>
          </div>
        </>
      ),
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 22,
      label: "Created at",
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 23,
      label: "",
      render: (row) => (
        <ActionDropDown
          row={row}
          handleTicketOpen={handleTicketOpen}
          setInvoiceModal={setInvoiceModal}
          printDeclaration={printDeclaration}
          labelDownloading={labelDownloading}
          CircularLoader={CircularLoader}
          printLabel={printLabel}
          handleReShip={handleReShip}
          setConfirmCancel={setConfirmCancel}
        />
      ),
      width: "350px",
      fixed: "right",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
  ];
  const getAllShipments = async (page, perPage, filter) => {
    const response = await fetchShipments("all", page, perPage, filter);
    if (!response.error) {
      setShipments(response?.data?.result?.shipments);
      dispatch(
        updateUser({
          unReadShipments: response?.data?.result?.unReadShipmentCount,
        }),
      );
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: "Something went wrong",
          severity: "error",
        };
      });
    }
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "5px 5px" }}
    >
      <Confirm
        open={confirmCancel}
        setOpen={setConfirmCancel}
        handleConfirm={() => handleCancelShipment(confirmCancel)}
        text="Do you want to cancel this shipment?"
        loader={cancelingShipment}
        cancelLabel="Keep shipment"
        confirmLabel="Cancel shipment"
      />
      <InvoiceModal
        open={!!invoiceModal}
        data={invoiceModal}
        setData={setInvoiceModal}
        setShipments={setShipments}
        setOpen={setInvoiceModal}
        getAllShipments={getAllShipments}
        setSnack={setSnack}
      />
      <TicketCreateModal
        open={!!ticketCreateModal}
        setOpen={setTicketCreateModal}
        previousData={ticketCreateModal}
        setSnack={setSnack}
      />
      <AssignPickup
        open={assignPickupModal}
        setOpen={setAssignPickupModal}
        setSnack={setSnack}
        setShipments={setShipments}
      />
      <PackageImageUploadModal
        open={packageImageUploadModal}
        onClose={() => {
          setPackageImageUploadModal(false);
          setSelectedShipmentForUpload(null);
        }}
        shipment={selectedShipmentForUpload}
        onSuccess={() => {
          setRefreshKey((prev) => prev + 1);
          getAllShipments(1, 20, "");
        }}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ShipmentsTable
          tableTitle="Shipments"
          tableId="shipments12TableforOneTimeShipper"
          message={"No Shipments Available To Display!"}
          searchPlaceHolder={"Search Shipments"}
          getAllData={getAllShipments}
          data={shipments}
          columns={columns}
          refresh={`all-${refreshKey}`}
        />
      </div>
    </div>
  );
};

export default OneTimeShipperShipments;
